/* eslint-disable @okta/okta-ui/enforce-requirejs-names, @okta/okta-ui/no-specific-modules */
import $ from 'jquery';

export interface OktaJQuery extends JQuery<HTMLElement> {
  scrollParent(includeHidden?: boolean): JQuery<HTMLElement>; // from jquery-ui
}

// src/vendor/lib/jquery.browser.js
export interface OktaJQueryBrowserPlugin {
  msie: boolean;
  opera: boolean;
  chrome: boolean;
  safari: boolean;
  mozilla: boolean;
  platform: 'ipad' | 'iphone' | 'android' | 'windowsPhone';
  mac: boolean;
  versionNumber: number;
}
export interface OktaJQueryStatic extends JQueryStatic {
  (
    selector: JQuery.Selector,
    context?: Element | Document | JQuery | JQuery.Selector
  ): OktaJQuery;
  fn: OktaJQuery;

  // Make sure you import following in order to use the 'browser' object
  // `import @okta/courage/src/vendor/plugins/jquery.browser`;
  // TODO: create a jquery.browser wrapper which could extend OktaJQueryStatic
  browser: OktaJQueryBrowserPlugin;
}

$.ajaxSetup({
  beforeSend: function (xhr) {
    xhr.setRequestHeader('X-Okta-XsrfToken', $('#_xsrfToken').text());
  },
  converters: {
    'text secureJSON': function (str) {
      if (str.substring(0, 11) === 'while(1){};') {
        str = str.substring(11);
      }
      return JSON.parse(str);
    }
  }
});

// Selenium Hook
// Widget such as autocomplete and autosuggest needs to be triggered from the running version of jQuery.
// We have 2 versions of jQuery running in parallel and they don't share the same events bus

const oktaJQueryStatic = $ as OktaJQueryStatic;
window.jQueryCourage = oktaJQueryStatic;
export default oktaJQueryStatic;
